// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"8672afc3223d32381377","678":"eb94ec5a69b484c25944","883":"d2d296e2db986e9de5f0"}[chunkId] + ".js";
};